// extracted by mini-css-extract-plugin
module.exports = {"avatar":"P9HW8y2_","circle":"D0Yvsg4Q","withBorder":"__5UuHFVGk","official":"TK06iinC"};